import React from 'react';
import './DailyRewardCard.css';

interface DailyRewardCardProps {
  day: number;
  type: 'coin' | 'energy' | 'special';
  amount: number;
  claimed: boolean;
  available: boolean;
  isSpecial?: boolean;
  isToday?: boolean;
}

const DailyRewardCard: React.FC<DailyRewardCardProps> = ({
  day,
  type,
  amount,
  claimed,
  available,
  isSpecial = false,
  isToday = false
}) => {
  const energyIcon = "/images/checkin/energy.png";
  const coinIcon = "/images/checkin/coin.svg";

  if (isSpecial) {
    return (
      <div className={`daily-reward-card special ${claimed ? 'claimed' : ''} ${available ? 'available' : ''} ${isToday ? 'today' : ''}`}>
        <div className="day-header special-header">
          <span className="day-text">Day {day}</span>
        </div>
        <div className="reward-content special-content">
          <div className="reward-icons">
            <div className="energy-group">
              <img src={energyIcon} alt="Energy" className="energy-icon-svg" />
                <div className="reward-amount">x{amount}</div>
            </div>
          </div>
        </div>
        {claimed && 
            <div className='claimed-overlay'>
                <img src="/images/checkin/claimed.svg" alt="Claimed" className="check-mark" />
            </div>
        }
        <div className="card-border special-border"></div>
      </div>
    );
  }

  return (
    <div className={`daily-reward-card normal ${claimed ? 'claimed' : ''} ${available ? 'available' : ''} ${isToday ? 'today' : ''}`}>
        <div className="day-header">
            <span className="day-text">Day {day}</span>
        </div>
        <div className="reward-content">
            <div className="reward-iconn">
                <div className="energy-group">
                    <img src={energyIcon} alt="Energy" className="energy-icon-svg" />
                </div>
            </div>
            <div className="reward-amount">x{amount}</div>
        </div>
        {claimed && 
            <div className='claimed-overlay'>
                <img src="/images/checkin/claimed.svg" alt="Claimed" className="check-mark" />
            </div>
        }
      <div className="card-border"></div>
    </div>
  );
};

export default DailyRewardCard;
